/**
 *
 * @param {string} string
 * @returns {string} // String with first letter uppercase
 */
export default function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
